import type { ReactNode } from 'react';
import type { Tone } from '../domain/workstations';

export function Badge({
  tone = 'neutre',
  children,
}: {
  tone?: Tone;
  children: ReactNode;
}) {
  return <span className={`pastille pastille--${tone}`}>{children}</span>;
}
